export var SHOPGATE_CATALOG_GET_FILTERS='shopgate.catalog.getFilters';